import { Injectable, signal, computed } from '@angular/core';
import { ContentScoringItem, ContentScoringResult } from '../interfaces/content-scoring';

@Injectable({ providedIn: 'root' })
export class ContentScoringService {
    private _scoreResultSignal = signal<ContentScoringResult | null>(null);

    setScoreResult(scoreResult: ContentScoringResult) {
        this._scoreResultSignal.set(scoreResult);
    }
    currentlyLoadedListingId = signal<string | null>(null);

    mapContentScoringPascalCaseObjectToCamelCase(contentScoringPascalCase: any): ContentScoringResult {
        // If the response is already in camelCase format, return it as is.
        if (contentScoringPascalCase.contentScoreItems !== undefined && contentScoringPascalCase.totalScore !== undefined) {
            return contentScoringPascalCase as ContentScoringResult;
        }

        const mappedItems: ContentScoringItem[] = (contentScoringPascalCase.ContentScoreItems || []).map((item: any) => {
            const label = item.Label;
            const data = item.Data;

            if (data.Item) {
                return {
                    label,
                    data: {
                        item: {
                            itemName: data.Item.ItemName,
                            isCompleted: data.Item.IsCompleted,
                            itemIdentifier: data.Item.ItemIdentifier,
                        },
                    },
                    featureGroupId: item.FeatureGroupId,
                    featureDetailId: item.FeatureDetailId,
                    featureGroupFieldName: item.FeatureGroupFieldName,
                };
            }

            if (data.Items) {
                return {
                    label,
                    data: {
                        items: data.Items.map((i: any) => ({
                            itemName: i.ItemName,
                            isCompleted: i.IsCompleted,
                            itemIdentifier: i.ItemIdentifier,
                        })),
                        enforceExist: data.EnforceExist,
                    },
                    featureGroupId: item.FeatureGroupId,
                    featureDetailId: item.FeatureDetailId,
                    featureGroupFieldName: item.FeatureGroupFieldName,
                };
            }

            // With the current websocket response flow, there should never be a case where the data is neither an item nor items
            return null;
        });

        return {
            contentScoreItems: mappedItems,
            totalScore: contentScoringPascalCase.TotalScore,
            listingId: contentScoringPascalCase.ListingId,
        };
    }

    readonly scoreResult = this._scoreResultSignal;
}
